import { postRequest } from '../libs/AxiosService.util';

export async function serviceFetchSpotlites(params) {
    return await postRequest('spotlites', params);
}

export async function serviceGetSpotliteDetail(params) {
    return await postRequest('/spotlite/detail', params);
}

export async function serviceDownloadSpotlitesExcel(params) {
    return await postRequest('/spotlite/download', params);
}

export async function serviceUnpublishSpotlite(params) {
    return await postRequest('spotlite/unpublish', params);
}

export async function serviceGetSpotliteOrderDetails(params) {
    return await postRequest('/spotlite/order/details', params);
}
